window.highlightTerritory = (terrIDs) ->
    # Make sure we have the IDs in array format.
    terrIDs = [].concat(terrIDs)

    allAreHighlighted = true
    for t in terrIDs
        el = $("[data-territory='#{t}']").parent()
        if el.children('.highlighter').length is 0
            allAreHighlighted = false
            break

    deHighlightTerritories()

    if allAreHighlighted
        return false

    for t in terrIDs
        el = $("[data-territory='#{t}']").parent()
        if el.children('.highlighter').length is 0
            el.append('<div class="highlighter" onclick="deHighlightTerritories();">' +
                '<div class="v"></div><div class="h"></div></div>')

    return false

window.deHighlightTerritories = () ->
    $('.highlighter').remove()
    return false
